import { render, staticRenderFns } from "./captains_create.vue?vue&type=template&id=17d66aad&"
import script from "./captains_create.vue?vue&type=script&lang=js&"
export * from "./captains_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports